import React from "react";
import {ArrowLeftIcon} from "@heroicons/react/24/outline";
import Button from "@ui-components/Button";
import {FormattedMessage} from "react-intl";

const EmptyStatePlaceholder = ({
  titleKey="no_documents_generic",
  descriptionKey="no_documents_generic_description",
  actionIcon=ArrowLeftIcon,
  actionTextKey="return_to_worksite",
  actionOnClick=() => {},
  customActionComponent=null,
  backgroundClass="bg-gray-100",
}) => {

  return (
    <div className={`w-full p-10 mx-auto flex flex-col items-center gap-4 ${backgroundClass}`}>
      <h2 className="text-2xl">
        <FormattedMessage id={titleKey}/>
      </h2>
      <p className="text-base mb-2">
        <FormattedMessage id={descriptionKey}/>
      </p>
      {customActionComponent ?
        customActionComponent :
        <Button
          styleType="empty"
          onClick={actionOnClick}
          Icon={actionIcon}
        >
          <FormattedMessage id={actionTextKey}/>
        </Button>
      }
    </div>
  )
}

export default EmptyStatePlaceholder;